package com.essntl.features.contact.domain.model

import com.essntl.features.address.domain.model.AddressModel
import com.essntl.features.organization.domain.model.OrganizationModel

data class ContactModel(
    val id: String,
    val firstName: String?,
    val lastName: String?,
    val email: String?,
    val phoneNumber: String?,
    val address: AddressModel?,
    val notes: String?,
    val organization: OrganizationModel?,
    val salutation: String?,
    val dateOfBirth: String?,
    val createdAt: String,
    val updatedAt: String,
) {
    val prettyName
        get() = "${firstName.orEmpty()} ${lastName.orEmpty()}"

    val prettyNamePhone
        get() = prettyName + phoneNumber?.let { p -> " - $p" }.orEmpty()

    fun getChangedFields(contact: ContactModel) =
        ContactModel(
            id = id,
            createdAt = createdAt,
            updatedAt = updatedAt,
            firstName = if (firstName.orEmpty() != contact.firstName.orEmpty()) contact.firstName else null,
            lastName = if (lastName.orEmpty() != contact.lastName.orEmpty()) contact.lastName else null,
            email = if (email.orEmpty() != contact.email.orEmpty()) contact.email else null,
            phoneNumber = if (phoneNumber.orEmpty() != contact.phoneNumber.orEmpty()) contact.phoneNumber else null,
            address = if (address?.id != contact.address?.id) contact.address else null,
            notes = if (notes.orEmpty() != contact.notes.orEmpty()) contact.notes else null,
            organization = if (organization?.id != contact.organization?.id) contact.organization else null,
            salutation = if (salutation.orEmpty() != contact.salutation.orEmpty()) contact.salutation else null,
            dateOfBirth = if (dateOfBirth.orEmpty() != contact.dateOfBirth.orEmpty()) contact.dateOfBirth else null,
        )

    val isEmpty
        get() = this.copy(id = "", createdAt = "", updatedAt = "") == empty

    companion object {
        val empty =
            ContactModel(
                id = "",
                createdAt = "",
                updatedAt = "",
                firstName = null,
                lastName = null,
                email = null,
                phoneNumber = null,
                address = null,
                notes = null,
                organization = null,
                salutation = null,
                dateOfBirth = null,
            )
    }
}